export type WorkerResponse<T> = {
  eventPrefix: string;
  data: T | undefined;
};

/**
 * Events can be fired in general by this worker or "subworkers"/VisualizationPrefix.
 * So an event can look like this: {uuid}_{SubWorkerName}_{EventTypes}
 * But also this is possible: {uuid}_{EventTypes} or {uuid}_{SubWorkerName}_{SubPart}_{EventTypes}
 * If you subscribe to a more specific event you dont need to subscribe to the broader event.
 */
export enum EventTypes {
  WorkerAvailable = "workerAvailable",
  Status = "status",
  Progress = "progress",
  StartedCalculation = "startedCalculation", //This is a general indicator if the Worker is doing any work. This indicates that it started working again
  DataReady = "dataReady", //This is a general indicator if the Worker is doing any work. This indicates that it ended working. After this is fired the data can be refetched by the other side
}

export class BaseWorker<SubWorkers extends Record<string, BaseWorker> = Record<string, never>> {
  isCalculating = false;
  identifier: string;

  protected subworkers: SubWorkers;

  constructor(identifier: string) {
    this.identifier = identifier;
    this.subworkers = {} as SubWorkers;
  }

  getSubworkerNames() {
    const subworkerNames = Object.keys(this.subworkers);
    return subworkerNames;
  }

  async recalculate() {
    this.setIsCalculating(true);
    const subworkerNames = this.getSubworkerNames();
    for (const element of subworkerNames) {
      const subworker = this.subworkers[element];
      await subworker?.recalculate();
    }
    this.setIsCalculating(false);
  }

  setIsCalculating(value: boolean) {
    this.isCalculating = value;

    // Only Emit the event if data is available
    postMessage({
      type: "event",
      eventType: `${this.identifier}_${value ? EventTypes.StartedCalculation : EventTypes.DataReady}`,
    });
  }

  terminate() {
    /**
     * TODO: close fetch requests when this worker gets terminated
     */

    const subworkerNames = this.getSubworkerNames();
    for (const element of subworkerNames) {
      const subworker = this.subworkers[element];
      subworker.terminate();
    }
    self.close();
  }
}
